import { type GetFeatureFlagsQueryParams } from '@gonfalon/openapi/operations/getFeatureFlags';

import { creationDateToReferenceDate } from './creationDateToReferenceDate';
import { isDeprecatedFilterEnabled } from './deprecatedFilterUtils';
import { evaluationDateToReferenceDate } from './evaluationDateToReferenceDate';
import { defaultFlagFilter } from './internal/defaultFlagFilter';
import { type UIFlagFilter } from './types';

export function parseUIFlagFilterFromAPI(api: NonNullable<GetFeatureFlagsQueryParams['filter']>) {
  const ui: UIFlagFilter = structuredClone(defaultFlagFilter);

  if (api.query) {
    ui.query = api.query;
  }

  if (isDeprecatedFilterEnabled('hasDataExport') && api.hasDataExport !== undefined) {
    ui.hasDataExport = api.hasDataExport;
  }

  if (api.hasExperiment) {
    ui.hasExperiment = api.hasExperiment;
  }

  if (api.maintainerId) {
    ui.maintainerId = api.maintainerId;
  }

  if (api.maintainerTeamKey) {
    ui.maintainerTeamKey = api.maintainerTeamKey;
  }

  if (api.tags && api.tags.length > 0) {
    ui.tags = api.tags;
  }

  if (api.type) {
    ui.type = api.type;
  }

  if (api.sdkAvailability) {
    ui.sdkAvailability = api.sdkAvailability;
  }

  if (api.guardedRollout) {
    ui.guardedRollout = api.guardedRollout;
  }

  if (api.filterEnv) {
    ui.filterEnv = api.filterEnv;
  }

  if (api.view) {
    ui.view = api.view;
  }

  if (isDeprecatedFilterEnabled('status') && api.status) {
    ui.status = api.status;
  }

  if (api.state || api.staleStates) {
    ui.state = api.state || api.staleStates;
  }

  if (isDeprecatedFilterEnabled('targeting') && api.targeting) {
    ui.targeting = api.targeting;
  }

  if (isDeprecatedFilterEnabled('contextKindTargeted') && api.contextKindTargeted) {
    ui.contextKindTargeted = api.contextKindTargeted;
  }

  if (
    isDeprecatedFilterEnabled('contextKindsEvaluated') &&
    api.contextKindsEvaluated &&
    api.contextKindsEvaluated.length > 0
  ) {
    ui.contextKindsEvaluated = api.contextKindsEvaluated;
  }

  if (isDeprecatedFilterEnabled('followerId') && api.followerId) {
    ui.followerId = api.followerId;
  }

  if (api.applicationEvaluated) {
    ui.applicationEvaluated = api.applicationEvaluated;
  }

  if (api.segmentTargeted) {
    ui.segmentTargeted = api.segmentTargeted;
  }

  if (api.codeReferences) {
    if (api.codeReferences.min !== undefined && api.codeReferences.min > 0) {
      ui.codeReferences = true;
    } else {
      ui.codeReferences = false;
    }
  }

  const now = Date.now();

  if (api.evaluated) {
    ui.evaluated = evaluationDateToReferenceDate(new Date(api.evaluated.after).getTime(), now);
  }

  if (api.creationDate) {
    ui.created = creationDateToReferenceDate(new Date(api.creationDate.before).getTime(), now);
  }

  return ui;
}
